import React from 'react'
import { useSelector } from 'react-redux'
import { OBJECTION_MODAL_STAGE } from './constants'
import { Objections } from './components'

function stages({ ...props }) {
  return {
    [OBJECTION_MODAL_STAGE.INITIAL]: <Objections {...props} />,
  }
}

export function ObjectionsModal() {
  const { stage, data } = useSelector(({ modal }) => modal)

  return stages({ data })[stage]
}
